import React, { useEffect, useState } from 'react';
import { ImageRequestParams } from "../../../infrastructure/models/params/image-request-params";
import { BaseImageProps } from "./base-image";
import { THEME } from "../../app/consts";
import { useFallbackRef } from "../../../infrastructure/hooks/useFallbackRef";
import { Image } from "./image";

export class SVGImageProps extends BaseImageProps {
  src: ImageRequestParams;
  eager: Boolean;
  theme: THEME;
  fillcolor: string;
  strokeColor: string;
  hoverFillColor: string;
  hoverStrokeColor: string;
}

export const SVGImage = React.forwardRef((props: SVGImageProps, forwardedRef) => {
  const ref = useFallbackRef(forwardedRef);
  const {fillcolor, strokeColor, hoverFillColor, hoverStrokeColor} = props;
  const [src, setSrc] = useState(null);

  // Handle hover color change
  const [hovered, setHovered] = useState(false);

  // Determine the final color to use for the SVG
  const finalFillColor = hoverFillColor && hovered ? hoverFillColor : fillcolor;
  const finalStrokeColor = hoverStrokeColor && hovered ? hoverStrokeColor : strokeColor;

  useEffect(() => {
    fetch(props.src)
      .then(response => response.text())
      .then(svgText => {
        const div = document.createElement('div');
        div.innerHTML = svgText;

        const filteredElements = div.querySelectorAll('[filter]');
        filteredElements.forEach(el => el.removeAttribute('filter'));

        const paths = div.querySelectorAll('path');
        paths.forEach(path => {
          // NEW: Skip paths that are inside <defs> or <mask>
          // This prevents the "mask" from turning black and hiding the icon
          if (path.closest('defs') || path.closest('mask')) {
            return;
          }

          if (finalStrokeColor) path.setAttribute('stroke', finalStrokeColor);
          if (finalFillColor) path.setAttribute('fill', finalFillColor);
        });

        setSrc('data:image/svg+xml,' + encodeURIComponent(div.innerHTML));
      });
  }, [props.src, finalStrokeColor, finalFillColor]);

  return (
    src ? <Image
      {...props}
      ref={ref}
      src={src}
      onMouseEnter={() => setHovered(true)}  // Set hover state on hover
      onMouseLeave={() => setHovered(false)} // Reset hover state when mouse leaves
    /> : null
  );
});